






import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import { elements } from "@/models/elementMenuItem.ts";
import { ElementType } from "@/models/element";
import ComponentsListItem from "@/components/ComponentsListItem.vue";

@Component({
  components: {
    ComponentsListItem
  }
})
export default class ComponentsLis extends Vue {
  private search = "";
  private elements = elements;

  private get filteredElements() {
    return this.elements.filter(x => x.text.includes(this.search));
  }

  private get elementsFront() {
    return this.elements.filter(
      x => x.type == ElementType.FRONT && !x.subElements.length
    );
  }

  private get elementsDoubleFront() {
    return this.elements.filter(
      x => x.type == ElementType.FRONT && x.subElements.length
    );
  }
}
